import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {



        this.load = new modularLoad({
            enterDelay: 500,
            transitions: {
                blog: {
                    loadingClass: 'is-loading-transition-blog',
                    enterDelay: 500
                }
            }
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {

            this.call('destroy', oldContainer, 'app')
            this.call('update', newContainer, 'app')

            if(transition !== 'blog') {
                this.call('scrollTo', { target: 0, immediate: true }, 'Scroll')
            } else {
                this.call('addScrollElements', newContainer, 'Scroll')
            }

            this.call('bindScrollTo', null, 'Scroll')

            this.initializePageScripts()
        })

        this.load.on('loading', (transition, oldContainer) => {
            this.call('close', null, 'Header')
            this.call('unbindScrollTo', null, 'Scroll')

            if(transition === 'blog') {
                this.call('removeScrollElements', oldContainer, 'Scroll')
                this.call('scrollTo', { target: '#content', offset: -150 }, 'Scroll')
            }

        })
    }

    goTo(obj) {
        this.load?.goTo(obj.url, obj.transition)
    }

    initializePageScripts() {
        // Example: Re-attach event listeners, initialize other libraries (like Locomotive Scroll), etc.
        jQuery(document).ready(function( $ ){

            //Table of Content Update
            let elContainer = $('.c-article_side_index-auto');
            if (elContainer.length > 0) {
                $('.-article h2').each(function() {
                    let el = $(this);
                    let text = $(this).html();
                    let id = text.replace(/[^a-zA-Z0-9]/g, "");
                    if (text.includes('<span id=')) {
                        console.log("ID Found");
                    } else {
                        el.attr('id', id);
                        el.addClass('toc-auto-header');
                    }
                })
            }

            // URL Param Update
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let utm_campaign = false;
            let utm_campaign_value = '';
            if (urlParams.has('utm_campaign')) {
                utm_campaign = true;
                utm_campaign_value = urlParams.get('utm_campaign');
            }

            let saved_campaign_value = localStorage.getItem('utm_campaign');
            if(saved_campaign_value !== null && saved_campaign_value !== '') {
                utm_campaign = true;
                utm_campaign_value = saved_campaign_value;
            } else if (utm_campaign_value !== '') {
                localStorage.setItem('utm_campaign', utm_campaign_value);
            }

            let utm_source = false;
            let utm_source_value = '';
            if (urlParams.has('utm_source')) {
                utm_source = true;
                utm_source_value = urlParams.get('utm_source');
            }

            let saved_source_value = localStorage.getItem('utm_source');
            if(saved_source_value !== null && saved_source_value !== '') {
                utm_source = true;
                utm_source_value = saved_source_value;
            } else if (utm_source_value !== '') {
                localStorage.setItem('utm_source', utm_source_value);
            }

            if (utm_campaign || utm_source) {
                $(".c-button").each(function() {
                    let el = $(this);
                    let url = el.attr('href');
                    if (url && (url.includes("utm_campaign") || url.includes("utm_source"))) {
                        if (url.includes("utm_campaign")) {
                            url = url.replace('VARIABLE_CAMPAIGN', utm_campaign_value);
                        }
                        if (url.includes("utm_campaign")) {
                            url = url.replace('VARIABLE_SOURCE', utm_source_value);
                        }
                        el.attr('href', url);
                    }
                });
            } else {
                $(".c-button").each(function() {
                    let el = $(this);
                    let url = el.attr('href');
                    if (url && (url.includes("utm_campaign") || url.includes("utm_source"))) {
                        if (url.includes("utm_campaign")) {
                            url = url.replace('VARIABLE_CAMPAIGN', 'swtch');
                        }
                        if (url.includes("utm_campaign")) {
                            url = url.replace('VARIABLE_SOURCE', 'website');
                        }
                        el.attr('href', url);
                    }
                });
            }

            console.log('SCRIPTS UPDATED...');
        });
    }
}
